module.exports = __webpack_public_path__ + "static/media/Vel25Megas.ff716220.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/Vel25Megas.svg
// module id = 112
// module chunks = 0